<template>
  <div>
    <el-dialog
      :visible.sync="dialogTableVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="payModel">
        <h3>支付仍在后台处理中 请耐心等待</h3>
        <p class="payModel_text">若一直没有收到支付结果，您可以:</p>
        <div class="payModel_btn">
          <el-button type="primary" @click="successDialog()">支付成功</el-button>
          <el-button @click="closeDialog">支付失败</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
    };
  },
  methods: {
    init() {
      this.dialogTableVisible = true;
    },
    successDialog(){
      this.dialogTableVisible = false;
      this.$parent.getModelOrderByUser();
      // this.$message({
      //   type: "info",
      //   message: "请至买家中心下载模型文件",
      // });
    },
    closeDialog(){
      this.dialogTableVisible = false;
      this.$parent.getModelOrderByUser();
    }
  },
};
</script>

<style lang="less" scoped>
.payModel {
    text-align: center;
    h3 {
        font-size: 22px;
        margin-bottom: 10px;
    }
    .payModel_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/model/payModelDialog.vue